import { RouteConfig } from 'vue-router';
import localizationFactory from "@/router/modules/localization-factory";

export default {
	name: "Plans",
	path: "/plans",
	component: () => import('../../views/Plans.vue'),
	meta: localizationFactory('menu.terms', {
		layout: "main",
	}),
} as RouteConfig;